import { ChevronDown, X } from "lucide-react";
import React, { useContext, useEffect, useState } from "react";
import { Button, Loader, Menu } from "@mantine/core";
import { Navigate } from "react-router-dom";
import Tag from "../../tags/services/model/Tag";
import ToggleAssigneeTagApiService from "../../tags/services/api/ToggleAssigneeTagApiService";
import { queryClient } from "../../../App";
import { AuthContext } from "../../../providers/AuthProvider";
import { HttpClientError } from "../../../providers/HttpClient";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type EmployeeTableTagDropdownProps = {
  employerId: number;
  employeeId: number;
  assignedTags: number[];
  activePage: number;
  tags: Tag[];
};

const EmployeeTableTagDropdown: React.FC<EmployeeTableTagDropdownProps> = ({
  employeeId,
  employerId,
  assignedTags,
  tags,
  activePage,
}) => {
  const auth = useContext(AuthContext);
  const { showToast } = useToasts();

  const [opened, setOpened] = useState(false);

  const { isError, isSuccess, error, isLoading, mutate } =
    ToggleAssigneeTagApiService();

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "employee_tag_remove_failed",
        data: {
          message: HttpClientError(error),
        },
      });
    }
  }, [isError]);

  useEffect(() => {
    if (isSuccess) {
      queryClient
        .invalidateQueries([
          "EmployeeListApiService",
          ...Object.values({
            employerId,
            pagination: true,
            page: activePage,
            tsAndCsAccepted: false,
            search: "",
          }),
        ])
        .then(() => {
          showToast({ strapiId: "employee_tag_remove_success" });
        });
    }
  }, [isSuccess]);

  if (!auth) {
    return <Navigate replace to="/login" />;
  }

  return (
    <Menu
      opened={opened}
      trigger="hover"
      control={
        <Button
          variant="outline"
          type="button"
          color="jem-theme"
          rightIcon={<ChevronDown size={18} />}
          onClick={() => setOpened((o) => !o)}
        >
          {" "}
          View all
        </Button>
      }
    >
      {tags
        .filter((it) => assignedTags.includes(it.id))
        .map((it) => (
          <Menu.Item
            key={`tag-menu-${it.id}`}
            rightSection={isLoading ? <Loader size="xs" /> : <X size={14} />}
            onClick={() =>
              mutate({
                tagId: it.id,
                employeeId,
                isTagged: false,
              })
            }
          >
            {it.name}
          </Menu.Item>
        ))}
    </Menu>
  );
};
export default EmployeeTableTagDropdown;
